/*
 * Copyright © 2026. Legalbird eine Marke der Legalbird GmbH
 */

import { useForm } from "@/src/provider/Form/FormProvider";
import MessageFormEditor from "@/src/components/Messaging/MessageForm/MessageFormEditor";
import React from "react";
import Button from "@mui/material/Button";
import { Stack } from "@mui/material";

export const MessageCenterMessageReplyForm = () => {
  const { handleSubmit } = useForm();

  return (
    <form onSubmit={handleSubmit}>
      <Stack spacing={"1rem"}>
        <MessageFormEditor />
        <Stack direction={"row"} sx={{ justifyContent: "flex-end" }}>
          <Button variant={"contained"} type={"submit"} sx={{ width: { xs: "100%", md: "auto" } }}>
            Weiter
          </Button>
        </Stack>
      </Stack>
    </form>
  );
};
